import React from "react";

import SortFieldsDropdown from "src/app/dropdowns/SortFieldsDropdown/SortFieldsDropdown";
import { FieldSelect } from "src/app/components/FieldSelect/FieldSelect";

export default function CreatorSearchSortFieldsDropdown({
  sortBy,
  setSortBy,
  sortOptions = [],
}) {
  const activeSortByName = sortOptions.find(
    (option) => option.uuid === sortBy,
  )?.name;

  const dropdownMenuItems = (clickFunction) =>
    sortOptions.map((field) => (
      <FieldSelect
        key={field.uuid}
        fieldId={field.uuid}
        fieldTitle={field.name}
        handleClick={() => {
          setSortBy(field.uuid);
          clickFunction?.();
        }}
        activeSortingColumn={sortBy}
      />
    ));

  return (
    <SortFieldsDropdown
      sortBy={activeSortByName}
      dropdownMenuItems={dropdownMenuItems}
    />
  );
}
